var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\"";
},"1":function(container,depth0,helpers,partials,data) {
    return "            <button class=\"btn btn-default action-cancel\">"
    + container.escapeExpression(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Action.Close",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":4,"column":58},"end":{"line":4,"column":81}}}))
    + "</button>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cancel") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":6,"column":12},"end":{"line":12,"column":19}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    return "                <button class=\"btn btn-default action-cancel\">"
    + container.escapeExpression(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Action.Cancel",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":7,"column":62},"end":{"line":7,"column":86}}}))
    + "</button>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"reset") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":16},"end":{"line":11,"column":23}}})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    return "                    <button class=\"btn btn-default action-cancel\">"
    + container.escapeExpression(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Action.Reset",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":10,"column":66},"end":{"line":10,"column":89}}}))
    + "</button>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"pull-right\">\n            <button class=\"btn btn-info action-submit\" type=\"submit\" "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"disabled") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":69},"end":{"line":17,"column":100}}})) != null ? stack1 : "")
    + ">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"save") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(9, data, 0),"data":data,"loc":{"start":{"line":18,"column":16},"end":{"line":26,"column":23}}})) != null ? stack1 : "")
    + "            </button>\n        </div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    return "disabled";
},"8":function(container,depth0,helpers,partials,data) {
    return "                    "
    + container.escapeExpression(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Action.Save",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":19,"column":20},"end":{"line":19,"column":42}}}))
    + "\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"compare") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.program(11, data, 0),"data":data,"loc":{"start":{"line":21,"column":20},"end":{"line":25,"column":27}}})) != null ? stack1 : "");
},"10":function(container,depth0,helpers,partials,data) {
    return "                        "
    + container.escapeExpression(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Action.Compare",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":22,"column":24},"end":{"line":22,"column":49}}}))
    + "\n";
},"11":function(container,depth0,helpers,partials,data) {
    return "                        "
    + container.escapeExpression(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Action.Forward",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":24,"column":24},"end":{"line":24,"column":49}}}))
    + "\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<footer "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"id") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":8},"end":{"line":1,"column":36}}})) != null ? stack1 : "")
    + " class=\"action-bar\">\n    <div class=\"pull-left\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"close") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(2, data, 0),"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":13,"column":15}}})) != null ? stack1 : "")
    + "    </div>\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"close") : depth0),{"name":"unless","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":4},"end":{"line":29,"column":15}}})) != null ? stack1 : "")
    + "</footer>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/shared-action-bar.hbs
// module id = seMS
// module chunks = 1